import React from "react";
import { observer } from "mobx-react";
import { TenantWidgetAccessViewStore } from "../../store";
import { TenantWidgetAccessViewForm } from "./TenantWidgetAccessViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TenantWidgetAccessViewProps = {
  tenantWidgetAccessViewStore: TenantWidgetAccessViewStore;
};

export const TenantWidgetAccessView: React.FC<TenantWidgetAccessViewProps> =
  observer(({ tenantWidgetAccessViewStore }) => {
    return (
      <div>
        <TenantWidgetAccessViewForm
          tenantValue={tenantWidgetAccessViewStore.tenantValue}
          widgetValue={tenantWidgetAccessViewStore.widgetValue}
          enabled={tenantWidgetAccessViewStore.enabledValue}
          configOverride={tenantWidgetAccessViewStore.configOverrideValue}
          onPrint={(handlePrint: () => void) =>
            tenantWidgetAccessViewStore.printTenantWidgetAccess(handlePrint)
          }
          onCancel={() =>
            tenantWidgetAccessViewStore.cancelTenantWidgetAccess()
          }
          onEdit={
            tenantWidgetAccessViewStore.isEditEnabled
              ? () => tenantWidgetAccessViewStore.editTenantWidgetAccess()
              : undefined
          }
        />
        <ErrorDialog
          open={tenantWidgetAccessViewStore.errorDialogOpened}
          title={tenantWidgetAccessViewStore.errorTitle}
          description={tenantWidgetAccessViewStore.errorDescription}
          onClose={() => tenantWidgetAccessViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
